import { OrderFrame } from '@ca/common'
import { BundleType } from '@ca/common/types'
import { OrderItem } from '@order/orderTypes'
import useBundleType from '../order/hooks/useBundleType'
import { useOrderState } from '../order/hooks/useOrderState'
import { useCallback } from 'react'

export const getCurrentFrameIndex = (orderItems: OrderItem[]) => {
  const index = orderItems.findIndex((i) => i.isCompleted)
  return index + 1
}

const getSelectedItem = (bundleType: BundleType) => {
  const state = useOrderState.getState()

  const bundleItems = state.order.items.filter(
    (i) => i.bundleType === bundleType
  )

  const index = getCurrentFrameIndex(bundleItems)
  if (index === -1) {
    return undefined
  }

  return bundleItems[index]
}

export function useFrameActions({
  flowName,
}: {
  flowName: string | undefined
}) {
  const { bundleType } = useBundleType()

  const addItem = useOrderState((s) => s.addItem)
  const clearFrame = useOrderState((s) => s.clearFrame)
  const setFrame = useOrderState((s) => s.setFrame)
  const switchActiveItem = useOrderState((s) => s.switchActiveItem)

  const toggleSelect = useCallback(
    (frame: OrderFrame) => {
      const selectedItem = getSelectedItem(bundleType)
      const isSelected = selectedItem?.frame?.id === frame.id
      if (selectedItem) {
        switchActiveItem(selectedItem.id)
        if (isSelected) {
          clearFrame(selectedItem.id)
          return
        }
        setFrame({ frame, bundleType, flowName })
        return
      }

      // Add new item
      const item = addItem({ frame, bundleType, flowName })
      switchActiveItem(item.id)
    },
    [
      addItem,
      bundleType,
      clearFrame,
      setFrame,
      switchActiveItem,
      flowName,
    ]
  )

  return { toggleSelect }
}
